import request from "@/utils/request";

// 列表(主数据列表)
export function loadPayerListDataApi(data) {
  return request({
    url: "web/payerSetting/listData",
    method: "post",
    data
  });
}
// 导出
export function loadPayerExportDataApi(data) {
  return request({
    url: "web/payerSetting/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdatePayerApi(data) {
  return request({
    url: "web/payerSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initPayerApi(data) {
  return request({
    url: "web/payerSetting/init",
    method: "post",
    data
  });
}

// 下列选项数据
export function loadPayerSelectDataApi(data) {
  return request({
    url: "web/payerSetting/listSelectData",
    method: "post",
    data
  });
}
